import React from 'react';
import type {StepIconProps} from '@mui/material';
import {Box} from '@mui/material';
import {CarTaxiFront, Link, Newspaper, Router, Unplug, User} from 'lucide-react';

const CustomStepIcon = (props: StepIconProps) => {
  const { active, completed, icon } = props;
  const iconSize = 24;

  const icons: { [index: string]: React.ReactElement } = {
    1: <User size={iconSize} />,
    2: <Link size={iconSize} />,
    3: <CarTaxiFront size={iconSize} />,
    4: <Newspaper size={iconSize} />,
    5: <Router size={iconSize} />,
    6: <Unplug size={iconSize} />
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: active || completed ? 'primary.main' : 'text.disabled',
      }}
    >
      {icons[String(icon)]}
    </Box>
  );
};

export default CustomStepIcon;
